import { render, staticRenderFns } from "./HeatmapControl.vue?vue&type=template&id=308cf0fc"
import script from "./HeatmapControl.vue?vue&type=script&lang=js"
export * from "./HeatmapControl.vue?vue&type=script&lang=js"
import style0 from "./HeatmapControl.vue?vue&type=style&index=0&id=308cf0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports